import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField.js";
import {Money} from "../../../stem-core/localization/Money.js";
import {Currency} from "../../../stem-core/localization/CurrencyStore";


@globalStore
export class MerchantRevenue extends BaseStore("MerchantRevenue") {
    @field("Currency") currency: Currency;
    @field(Money) outstandingBalance: Money;
    @field(Money) allTimeRevenue: Money;
    // The server sends these two with the underscore intact: to_camel_case capitalises whole parts, and
    // "24h".capitalize() is already "24h", so last_24h_revenue camel-cases to last_24hRevenue
    @field(Money, {rawField: "last_24hRevenue"}) last24hRevenue: Money;
    @field(Money, {rawField: "last_30dRevenue"}) last30dRevenue: Money;
}
